import { Link } from 'react-router-dom'

import { Button } from '@/shared/components'
import { Alert, Box, FormLabel, styled, Typography } from '@mui/material'

export const StyledRegistration = styled('main')`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.palette.background.default};
  overflow-y: auto;
  
  ${props => props.theme.breakpoints.up('sm')} {
    height: 100vh;
  }
`

export const StyledForm = styled('form')`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const StyledLink = styled(Link)`
  color: ${props => props.theme.palette.text.primary};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: ${props => props.theme.typography.pxToRem(14)};
  margin-top: ${props => props.theme.typography.pxToRem(12)};
  text-align: center;
  cursor: pointer;

  ${props => props.theme.breakpoints.up('md')} {
    margin-top: ${props => props.theme.typography.pxToRem(4)};
  }

  &:hover {
    color: ${props => props.theme.palette.custom.link.color};
  }
`

export const StyledSubmitButton = styled(Button)`
  margin-top: ${props => props.theme.typography.pxToRem(16)};

  ${props => props.theme.breakpoints.up('md')} {
    margin-top: ${props => props.theme.typography.pxToRem(28)};
  }
`

export const StyledAlert = styled(Alert)`
  align-self: stretch;
  margin-bottom: ${props => props.theme.typography.pxToRem(16)};
`

export const StyledTextFieldLabel = styled(FormLabel)`
  margin-top: ${props => props.theme.typography.pxToRem(16)};
`

export const StyledContainer = styled(Box)`
  width: 100%;
  max-width: ${props => props.theme.typography.pxToRem(1200)};
  padding: ${props => props.theme.typography.pxToRem(20)};
  display: flex;
  flex-direction: column;
  align-items: center;
  
  ${props => props.theme.breakpoints.up('lg')} {
    flex-direction: row;
    align-items: stretch;
  }
`

export const StyledLeftSection = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  
  ${props => props.theme.breakpoints.up('lg')} {
    width: 50%;
    align-items: flex-start;
    padding-right: ${props => props.theme.typography.pxToRem(80)};
    margin-bottom: 0;
  }
`

export const StyledRightSection = styled(Box)`
  width: 100%;
  max-width: ${props => props.theme.typography.pxToRem(480)};
  padding: ${props => props.theme.typography.pxToRem(32)};
  border-radius: ${props => props.theme.typography.pxToRem(16)};
  background-color: ${props => props.theme.palette.background.paper};
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  
  ${props => props.theme.breakpoints.up('lg')} {
    width: 50%;
  }
`

export const StyledLogo = styled('img')`
  width: ${props => props.theme.typography.pxToRem(160)};
  margin-bottom: ${props => props.theme.typography.pxToRem(64)};
`

export const StyledFeatureList = styled(Box)`
  display: none;
  
  ${props => props.theme.breakpoints.up('lg')} {
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.typography.pxToRem(20)};
    max-width: 80%;
  }
`

export const StyledFeatureItem = styled(Box)`
  display: flex;
  align-items: flex-start;
  gap: ${props => props.theme.typography.pxToRem(12)};
`

export const StyledFeatureIcon = styled(Box)`
  width: ${props => props.theme.typography.pxToRem(24)};
  height: ${props => props.theme.typography.pxToRem(24)};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.palette.primary.main};
`

export const StyledFeatureText = styled(Box)`
  color: ${props => props.theme.palette.text.primary};
  flex: 1;
`

export const StyledFeatureTitle = styled(Typography)`
  font-weight: 600;
  margin-bottom: ${props => props.theme.typography.pxToRem(4)};
`

export const StyledFeatureDescription = styled(Typography)`
  color: ${props => props.theme.palette.text.secondary};
`

export const StyledDivider = styled(Box)`
  display: flex;
  align-items: center;
  margin: ${props => props.theme.typography.pxToRem(24)} 0;
  
  &:before, &:after {
    content: "";
    flex: 1;
    border-bottom: 1px solid ${props => props.theme.palette.divider};
  }
  
  &:before {
    margin-right: ${props => props.theme.typography.pxToRem(16)};
  }
  
  &:after {
    margin-left: ${props => props.theme.typography.pxToRem(16)};
  }
`

export const StyledSocialButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.typography.pxToRem(8)};
  width: 100%;
  margin-bottom: ${props => props.theme.typography.pxToRem(12)};
`

export const StyledSocialIcon = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledTermsText = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(12)};
  text-align: center;
  color: ${props => props.theme.palette.text.secondary};
  margin-top: ${props => props.theme.typography.pxToRem(24)};
`
